var _style, _rect, _polyline, _line, _line2, _line3, _line4, _line5, _line6, _line7, _line8, _polygon;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDeviceActivatedPneumaticHydraulicSa({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 16 16",
    style: {
      enableBackground: "new 0 0 16 16"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:none;stroke:#FFFFFF;stroke-width:0.25;stroke-miterlimit:10;}\n\t.st1{fill:#FFFFFF;stroke:#FFFFFF;stroke-width:0.25;stroke-miterlimit:10;}\n")), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.6,
    y: 6.5,
    className: "st0",
    width: 12,
    height: 5.3
  })), _polyline || (_polyline = /*#__PURE__*/React.createElement("polyline", {
    className: "st0",
    points: "6.6,6.5 6.6,9.2 6.6,11.8 "
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    className: "st0",
    x1: 7.4,
    y1: 9.2,
    x2: 6.6,
    y2: 9.2
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    className: "st0",
    x1: 8.6,
    y1: 9.2,
    x2: 7.9,
    y2: 9.2
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    className: "st0",
    x1: 10,
    y1: 9.2,
    x2: 9.3,
    y2: 9.2
  })), _line4 || (_line4 = /*#__PURE__*/React.createElement("line", {
    className: "st0",
    x1: 11.5,
    y1: 9.2,
    x2: 10.7,
    y2: 9.2
  })), _line5 || (_line5 = /*#__PURE__*/React.createElement("line", {
    className: "st0",
    x1: 13,
    y1: 9.2,
    x2: 12.2,
    y2: 9.2
  })), _line6 || (_line6 = /*#__PURE__*/React.createElement("line", {
    className: "st0",
    x1: 14.4,
    y1: 9.2,
    x2: 13.7,
    y2: 9.2
  })), _line7 || (_line7 = /*#__PURE__*/React.createElement("line", {
    className: "st0",
    x1: 15.6,
    y1: 9.2,
    x2: 14.9,
    y2: 9.2
  })), _line8 || (_line8 = /*#__PURE__*/React.createElement("line", {
    className: "st0",
    x1: 2.2,
    y1: 4.7,
    x2: 9,
    y2: 4.7
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "8.7,4.3 8.7,5.1 10,4.6 "
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeviceActivatedPneumaticHydraulicSa);
export default __webpack_public_path__ + "static/media/DeviceActivatedPneumaticHydraulicSA.be00f170a6fd16b4a8d8d73f1e8fe256.svg";
export { ForwardRef as ReactComponent };